import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\anton\\12-25-anton - Copie - Copie - Copie\\node_modules\\next-intl\\dist\\esm\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\anton\\12-25-anton - Copie - Copie - Copie\\src\\app\\ui\\Analytics.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\anton\\12-25-anton - Copie - Copie - Copie\\src\\utils\\WebVitalsClient.tsx");
